import { usePageContext } from '@merchant-portal/framework';
import { hooks as i18nHooks } from 'mage-i18n';
import { TrackImpression } from 'mage-insights';
import React, { useEffect } from 'react';
import useSetBoostersHomeSubmenu from '../../../../hooks/useSetBoostersHomeSubmenu';
import { PLUGINS } from '../../constants';
import Plugins from './components/Plugins';
export default function BoostPluginsPage() {
    const t = i18nHooks.useTranslator();
    const { setPageContext = () => { } } = usePageContext();
    const setBoostersHomeSubmenu = useSetBoostersHomeSubmenu();
    useEffect(() => {
        setPageContext({
            title: t('home-fe.boosters-plugins.title'),
            description: t('home-fe.boosters-plugins.description')
        });
    }, [t, setPageContext]);
    useEffect(() => {
        setBoostersHomeSubmenu();
    }, [setBoostersHomeSubmenu]);
    const event = {
        category: 'boost-home/plugin-overview',
        action: 'impression'
    };
    return (React.createElement(TrackImpression, { event: event },
        React.createElement("div", { id: 'boost-plugins-page' },
            React.createElement(Plugins, { plugins: PLUGINS }))));
}
